import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { FormPageFieldComponentProps } from 'types/formPage';
import { isTypeCurrency, isTypePercent } from 'data';
import { getAPIVersion } from 'helpers/getAirtableMetaAPIVersion';
import {wrapComponent, extract, FieldTypes} from "../../utils";
import {changeOnBlur} from "./common";

const BaseNumber = (props: FormPageFieldComponentProps) => {
  const { extraConfig = {} as any, name, onChange: onChangeFinal, value:valueInit, onBlur:onBlurFinal, ...rest } = props;
  const {value, onChange, onBlur} = changeOnBlur( name, valueInit, onChangeFinal, onBlurFinal, 'change' )
  let {maxFractionDigits, minFractionDigits} = extraConfig
  if(minFractionDigits)extraConfig.maxFractionDigits = Math.max(minFractionDigits,maxFractionDigits)
  //console.log('Number Config', extraConfig)
  const comp = (
    <InputNumber
      name={name}
      {...extract( {showButtons:undefined, buttonLayout: undefined, prefix: undefined, suffix: undefined,
        min: undefined, max: undefined, locale: undefined, currency: undefined, currencyDisplay: undefined,
        step: undefined, format:undefined, useGrouping:undefined,minFractionDigits:undefined,maxFractionDigits:undefined,
        allowEmpty:undefined,pattern:undefined,inputmode:undefined,localeMatcher:undefined}, extraConfig, rest)}
      value={value}
      onBlur={onBlur}
      onValueChange={onChange}
    />
  );
  return wrapComponent( comp, extraConfig)
};

export default BaseNumber;
